import Offcanvas from 'react-bootstrap/Offcanvas';
import 'bootstrap/dist/css/bootstrap.min.css';
import { RxCross2 } from "react-icons/rx";
import { Box, Typography } from '@mui/material';
import { IoIosArrowDown } from "react-icons/io";
import { customTextColor } from '../../utils/const';
import { useState } from 'react';
import { StylesContext } from '@mui/styles';
import styles from "./PostRequirement.module.css";
import { IoIosArrowUp } from "react-icons/io";
function SideDrawer({ handleClose, show }) {

    const [showAllData, setShowAllData] = useState("0")

    return (
        <Offcanvas show={show} onHide={handleClose} placement="end" scroll={false} backdrop={false} style={{ border: "none", marginTop: "74px", width: "470px", padding: "0 0 0 10px" }}>
            <Offcanvas.Header style={{ display: "flex", justifyContent: 'space-between', alignItems: 'center' }}>
                <Offcanvas.Title style={{ fontWeight: '600', color: customTextColor }}>Kevin Macklin - Submission History</Offcanvas.Title>
                <RxCross2 style={{ fontSize: '22px', cursor: 'pointer', color: customTextColor }} onClick={handleClose} />
            </Offcanvas.Header>
            <Offcanvas.Body>
                <Box sx={{ color: customTextColor }} className={styles.canvas_body}>
                    <span>
                        <Typography>
                            Position : <b>Lead Java Developer at Dallas Taxes, TX</b>
                        </Typography>
                        <Typography>
                            Vendor : <b>Deep Learning Pvt Ltd</b>
                        </Typography>
                        <Typography>
                            Client : <b>Capital One</b>
                        </Typography>
                        <Typography sx={showAllData === "1" ? { display: 'flex', alignItems: "center", justifyContent: 'space-between' } : { marginBottom: "0 !important", display: 'flex', alignItems: "center", justifyContent: 'space-between' }}>
                            <span> Date : <b>12 August 2024, 11:30 PM</b> </span>
                            {
                                (showAllData === "0" || showAllData === "2" || showAllData === "3") &&
                                <IoIosArrowDown onClick={() => setShowAllData("1")} />
                            }
                        </Typography>
                        {
                            showAllData === "1" &&
                            <>
                                <Typography>
                                    Submitted by : <b>Paresh Sahoo</b>
                                </Typography>

                                <Typography sx={{ marginBottom: "0 !important", display: 'flex', alignItems: "center", justifyContent: 'space-between' }}>
                                    <span> Designation : <b>Senier IT Recruiter</b>  </span>    <IoIosArrowUp onClick={() => setShowAllData("0")} />
                                </Typography>
                            </>

                        }
                    </span>
                    <hr />
                </Box>

                <Box sx={{ color: customTextColor }} className={styles.canvas_body}>
                    <span>
                        <Typography>
                            Position : <b> Full Stack Developer at Georgia, GA</b>
                        </Typography>
                        <Typography>
                            Vendor : <b>Healthy Motion Pvt Ltd</b>
                        </Typography>
                        <Typography>
                            Client : <b>Master Card Inc</b>
                        </Typography>
                        <Typography sx={showAllData === "2" ? { display: 'flex', alignItems: "center", justifyContent: 'space-between' } : { marginBottom: "0 !important", display: 'flex', alignItems: "center", justifyContent: 'space-between' }}>
                            <span> Date : <b>12 August 2024, 11:30 PM</b> </span>
                            {
                                (showAllData === "0" || showAllData === "1" || showAllData === "3") &&
                                <IoIosArrowDown onClick={() => setShowAllData("2")} />
                            }
                        </Typography>
                        {
                            showAllData === "2" &&
                            <>
                                <Typography>
                                    Submitted by : <b>Paresh Sahoo</b>
                                </Typography>

                                <Typography sx={{ marginBottom: "0 !important", display: 'flex', alignItems: "center", justifyContent: 'space-between' }}>
                                    <span> Designation : <b>Senier IT Recruiter</b>  </span>    <IoIosArrowUp onClick={() => setShowAllData("0")} />
                                </Typography>
                            </>

                        }

                    </span>
                    <hr />
                </Box>

                <Box sx={{ color: customTextColor }} className={styles.canvas_body}>
                    <span>
                        <Typography>
                            Position : <b>Senior Java Developer at Georgia, GA</b>
                        </Typography>
                        <Typography>
                            Vendor : <b>Livix Tech Pvt Ltd</b>
                        </Typography>
                        <Typography>
                            Client : <b>Humana Heathcare Inc</b>
                        </Typography>
                        <Typography sx={showAllData === "3" ? { display: 'flex', alignItems: "center", justifyContent: 'space-between' } : { marginBottom: "0 !important", display: 'flex', alignItems: "center", justifyContent: 'space-between' }}>
                            <span> Date : <b>12 August 2024, 11:30 PM</b> </span>
                            {
                                (showAllData === "0" || showAllData === "2" || showAllData === "1") &&
                                <IoIosArrowDown onClick={() => setShowAllData("3")} />
                            }
                        </Typography>
                        {
                            showAllData === "3" &&
                            <>
                                <Typography>
                                    Submitted by : <b>Paresh Sahoo</b>
                                </Typography>

                                <Typography sx={{ marginBottom: "0 !important", display: 'flex', alignItems: "center", justifyContent: 'space-between' }}>
                                    <span> Designation : <b>Senier IT Recruiter</b>  </span>    <IoIosArrowUp onClick={() => setShowAllData("0")} />
                                </Typography>
                            </>

                        }

                    </span>
                    <hr />
                </Box>

            </Offcanvas.Body>
        </Offcanvas>
    );
}

export default SideDrawer;